/* eslint-disable global-require */
import React from 'react';
import _ from 'lodash';
import styles from './css/FlowersCta.styl';
import {getPageTypeFlowersCtaImage} from '../../../../shared/utilities/personPageType';

/**
 * click handler
 * @param  {string} link            flowers url
 * @param  {Function} trackingFunc  tracking function callback
 * @return {undefined}              returns nothing
 */
function handleClick(link, trackingFunc) {
  window.open(link, '_blank');
  if (_.isFunction(trackingFunc)) {
    trackingFunc();
  }
}

const FlowersCta = props => {
  const {flowerClickEvents, flowersLink, personPageType, showFlowers} = props;
  const img = require(`./assets/${getPageTypeFlowersCtaImage(personPageType)}`);

  return flowersLink && showFlowers ? (
    <aside
      className={styles.FlowersCta}
      onClick={_.partial(handleClick, flowersLink, flowerClickEvents)}
    >
      <h2>Show Your Sympathy</h2>
      <img src={img} />
      <div className={styles.link}>
        <p>Send Flowers</p>
      </div>
    </aside>
  ) : null;
};

FlowersCta.propTypes = {
  flowerClickEvents: React.PropTypes.func,
  flowersLink: React.PropTypes.string,
  personPageType: React.PropTypes.string,
  showFlowers: React.PropTypes.bool,
};

export default FlowersCta;



// WEBPACK FOOTER //
// ./src/reactModules/pages/Person/components/FlowersCta/FlowersCta.js